import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GameLog } from 'src/app/models/gameLog.model';
import { Portal } from 'src/app/models/portal.model';
import { Post } from 'src/app/models/post.model';
import { StorageService } from '../storage/storage.service';
import { PortalService } from '../portal/portal.service';
import * as moment from 'moment';

/*
  This service serves the purpose of sending data between two completly unrelated pages or components.

  Using a rxjs BehaviorSubject, you can subscribe in the page in which you'd like to recieve data and call 
  the helper function from the page which you'd like to send the data from.

  Currently used to pass posts between the tabs page and whichever feed the post / broadcast / game log is supposed to be sent to. 
*/

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private portalPage = new BehaviorSubject<[(boolean|null), number]>([null, moment().valueOf()]);
  isPortalPage = this.portalPage.asObservable();

  private postSource = new BehaviorSubject<Post|GameLog>(null);
  currentPost = this.postSource.asObservable();

  private portalScrollerPortalID = new BehaviorSubject<number|null>(null);
  selectedPortalScrollerPortalID = this.portalScrollerPortalID.asObservable();

  constructor(
    private storage: StorageService,
    private portalService: PortalService
  ) { }

  setPortalPageStatus(portal: Portal, timePageLoaded?: number) {
    if(portal) {
      this.storage.set('portal', portal);
      this.portalPage.next([true, timePageLoaded]);
      this.portalService.portal.next([portal, timePageLoaded]);
    } else {
      this.storage.remove('portal');
      this.portalPage.next([false, timePageLoaded]);
      this.portalService.portal.next([null, timePageLoaded]);
    }
  }

  sendPost(post: Post|GameLog) {
    this.postSource.next(post);
  }

  selectPortalScrollerPortal(portalID: number) {
    this.portalScrollerPortalID.next(portalID);
  }
}